<template>
    <div>
        <v-container ma-0 pa-0 px-4 class="container-with-horizontal-scroll" fluid>
            <promo-table/>
        </v-container>
        <v-snackbar
                v-model="paramsSnackbar.show"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>

import PromoTable from '../../components/bot/promo/PromoTable'

export default {
    name: 'Index',
    components: {
        PromoTable
    },
    data() {
        return {
            paramsSnackbar: {
                color: 'success',
                text: 'Операция прошла успешно!',
                show: false
            },
            snackbar: false,
            dialog: false,
            dialogParams: {},
            visibleHiddenGroups: false,
            windowHeight: 0,
            files: null,
            lastFile: {
                percent: 0,
                fileName: '',
                error: false
            }
        }
    },
    watch: {
        dialog() {
            if (this.dialog === false) {
                this.editCardId = null
                this.cardListId = null
            }
        }
    },
    methods: {
        handleResize() {
            this.windowHeight = window.innerHeight
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    computed: {
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
</style>
